import styles from './error.module.css';

export const ErrorPage = () => {
  return (
    <div className={styles.container}>
      <img className={styles.logo} src="logo.svg" alt="playwall logo" />

      <span className={styles.text}>
        Something went wrong... <br /> Try again later
      </span>
      <div />
    </div>
  );
};
